module.exports = __webpack_public_path__ + "static/media/payment.4c0bcd00.png";